
import { Container, HeaderContainer } from "./styles";

export function Header() {
    function scrollSmoothTo(elementId) {
        var element = document.getElementById(elementId);
        element.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
        });
    }
    
    return (
        <Container id="header">
            <HeaderContainer>
                <div>
                    <a href="/inicio">Renata e Wellton</a>
                </div>
                <nav>
                    <ul>
                        <li onClick={() => scrollSmoothTo('casal')}>
                            Casal
                        </li>
                        <li onClick={() => scrollSmoothTo('local')}>
                            Local
                        </li>
                        <li onClick={() => scrollSmoothTo('fotos')}>
                            Fotos
                        </li>
                        <li onClick={() => scrollSmoothTo('lista-de-presentes')}>
                            Lista de presentes
                        </li>
                        <li onClick={() => scrollSmoothTo('lista-de-presentes')}>
                            Confirmar presença
                        </li>
                        <li onClick={() => scrollSmoothTo('padrinhos')}>
                            Padrinhos
                        </li>
                        <li onClick={() => scrollSmoothTo('recado')}>
                            Recado para os noivos
                        </li>
                    </ul>
                </nav>
            </HeaderContainer>
        </Container >
    );
}
